var _rect, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwethLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2014_49266)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75.8853,
    y: 76.2036,
    width: 75.272,
    height: 75.272,
    transform: "rotate(-180 75.8853 76.2036)",
    fill: "url(#paint0_linear_2014_49266)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2014_49266",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 13,
    width: 33,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4193 40.0953L22.1279 40.5751L22.9313 41.7013C22.6848 41.1761 22.5237 40.6215 22.4193 40.0953ZM23.3701 38.5298C26.4866 40.0915 30.8932 39.6333 36.5897 37.1555C42.5748 34.5522 47.4786 34.2364 51.3011 36.2083C51.5408 36.332 51.7616 36.463 51.9649 36.6003L38.28 13.979L23.3701 38.5298ZM54.1705 40.2462C54.1925 40.4327 54.2057 40.6166 54.2121 40.7965L54.3694 40.5751L54.1705 40.2462ZM53.0459 42.4379C48.7251 39.1528 44.0232 39.3633 37.5868 42.1629C32.4354 44.4037 28.3388 44.9928 25.2971 43.9302C24.7571 43.7416 24.3115 43.4609 23.9438 43.1209L38.28 63.2194L53.0459 42.4379Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2014_49266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2839 13.916L37.8101 15.0219V38.6303H38.2839L55.6558 36.2153L38.2839 13.916Z",
    fill: "#7591F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2801 13.7905L23.0688 38.997L38.2801 47.9766V32.0919V13.7905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2451 41.9028L38.0581 51.0937V62.7358L38.2451 63.2814L54.1507 40.8257L47.0312 35.5566L38.2451 41.9028Z",
    fill: "#7591F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2801 63.2814L38.2801 41.9028H23.0688L38.2801 63.2814Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2014_49266",
    x1: 113.521,
    y1: 76.2036,
    x2: 112.783,
    y2: 203.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3068EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1322AC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2014_49266"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.613281,
    y: 0.931641,
    width: 75.272,
    height: 75.272,
    rx: 37.636,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwethLogo);
export default __webpack_public_path__ + "static/media/sweth-logo.debb03ec55cd4016b8660bccc3563745.svg";
export { ForwardRef as ReactComponent };